import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { withRouter, Route, Redirect } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

import store from 'root/admin/store';

@observer
export default class Subscription extends React.Component {
	@observable tab;

	render() {
		const rootPath = '/admin';
		const path = `${rootPath}/subscriptions`;
		return (
			<div>
				<Route exact path={path} component={() => <List rootPath={rootPath} path={path} />} />
				<Route exact path={`${path}/:id`} component={() => <Edit rootPath={rootPath} />} />
			</div>
		);
	}
}
